import axios from 'axios';
import {Message} from 'element-ui';
import store from '@/store';
import {getToken} from '@/utils/auth';
import router from './../router';
import {showFullScreenLoading, tryHideFullScreenLoading} from './loading-help';

// 读取配置文件中的请求地址
const baseURL = url.baseUrl;
const service = axios.create({
  baseURL: baseURL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000 // 请求超时20秒
});
let messageInstance = 0; // 只显示第一个错误，后面的拦截
let messageInstanceCount = 0;
// request interceptor
service.interceptors.request.use(
  config => {
    if (getToken()) {
      // 头部添加 token
      config.headers['Authorization'] = getToken();
      if (!config.params) config.params = {};
      config.params['version'] = '1.0';
      config.params['t'] = Math.random().toString(36).substring(2);
    }
    // 添加 loading  企业全部行业模块不添加全局loading
    if (config.url.indexOf('/company/industry/evaluation') < 0) {
      // 调用消息的接口不添加全局loading
      if (config.url.indexOf('/message/to_sent') < 0) {
        // 发送AI消息的接口不添加全局loading
        if (config.url.indexOf('/chat/send') < 0) {
          showFullScreenLoading();
        }
      }
    }
    messageInstanceCount++;
    return config;
  },
  error => {
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    if (response.config.url != '/message/to_sent') {
      tryHideFullScreenLoading();
    }
    messageInstanceCount--;
    return response.data;
  },
  error => {
    // if (messageInstance) {
    //   messageInstance.close();
    // }
    // 隐藏loading
    tryHideFullScreenLoading();
    messageInstanceCount--;
    if (window.location.hash.indexOf('/application') > -1) {
      return false;
    }
    // 如果是登录 或者 是申请免费咨询 页面，返回401后不刷新页面
    if (error.response && error.response.status === 401 && (window.location.hash.indexOf('/login') === -1)) {
      store.dispatch('user/clearInfo').then(() => {
        router.push('/login');
      }).catch(() => {
        router.push('/login');
      });
    }
    if (error && error.stack.indexOf('timeout') > -1 && messageInstance <= 0) {
      Message({
        message: '网络请求出错，请重试',
        type: 'error',
        offset: 100,
        duration: 5 * 1000
      });
      messageInstance++;
    } else {
      if (error.response.status === 500 && window.location.hash.indexOf('/login') === -1 && messageInstance <= 0) {
        Message({
          message: error.response.data.msg || error,
          type: 'error',
          offset: 100,
          duration: 5 * 1000
        });
        messageInstance++;
      }
      if (error.response.status === 403 && messageInstance <= 0) {
        Message({
          message: '权限不足，请联系客服',
          type: 'error',
          offset: 100,
          duration: 5 * 1000
        });
        messageInstance++;
      }
      if (error.response.status !== 500 && error.response.status !== 403) {
        if (error.response.data.code === 32005 || error.response.data.code === 32006 || error.response.data.code === 32009) {
          if (messageInstance <= 0) {
            // console.log(messageInstance)
            Message({
              message: '次数不足，请联系客服',
              showClose: true,
              type: 'error',
              offset: 100,
              duration: 5 * 1000
            });
            messageInstance++;
          }
        }
        // if (error.response.data.code === 30000 && messageInstance <= 0) {
        //   Message({
        //     message: '截止本应数据更新，暂无该企业数据',
        //     showClose: true,
        //     type: 'error',
        //     offset: 100,
        //     duration: 5 * 1000
        //   });
        //   messageInstance++;
        // }
      }

      if (error.response.status === 400 && error.response.data.code === 'sys.old_password_not_correct' && messageInstance <= 0) {
        Message({
          message: '原密码错误，请输入正确原密码',
          type: 'error',
          offset: 100,
          duration: 5 * 1000
        });
        messageInstance++;
      }
    }
    if (messageInstanceCount <= 0) {
      messageInstance = 0;
    }
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js